import React, { FC, useState } from 'react';

import { AtsType, IntegrationType } from 'src/generated/mloop-graphql';

import { AshbyIntegration, useIntegrationDelete } from 'src/hooks/api/integration';
import { getAtsService } from 'src/hooks/atsService';

import AshbyDialog from '../Dialogs/AshbyDialog';
import { DisconectAtsDialog } from '../Dialogs/DisconnectAtsDialog';
import IntegrationCard from '../IntegrationCard';

import { ConnectAtsButton } from './ConnectAtsButton';

export interface Props {
  ashby?: AshbyIntegration;
  disabled?: boolean;
  onConnect?: () => void;
  onRemove?: () => void;
}

const AshbyCard: FC<Props> = ({ ashby, disabled = false, onConnect, onRemove }) => {
  const [isDialogOpen, setDialogOpen] = useState<boolean>(false);
  const [openRemoveDialog, setOpenRemoveDialog] = useState<boolean>(false);

  const deleteAshby = useIntegrationDelete(IntegrationType.AshbyApiKey);

  const atsService = getAtsService(AtsType.Ashby);

  return (
    <>
      <IntegrationCard
        dataTestId="ashby-card-integration-card"
        logo={atsService.logoUrl}
        name="Ashby"
        onConnect={ashby ? undefined : () => setDialogOpen(true)}
        onManageSetup={ashby ? () => setDialogOpen(true) : undefined}
        onRemove={ashby ? () => setOpenRemoveDialog(true) : undefined}
        disabled={disabled}
        disableManageSetup={disabled}
        connectButton={
          <ConnectAtsButton
            dataTestId="ashby-card-integration-card"
            handleConnect={() => setDialogOpen(true)}
            disabled={disabled}
          />
        }
      />

      {isDialogOpen && (
        <AshbyDialog
          apiKey={ashby?.api_key || ''}
          syncConfidentialJobs={ashby?.sync_confidential_jobs || false}
          onClose={() => setDialogOpen(false)}
          onConnect={() => {
            setDialogOpen(false);
            onConnect?.();
          }}
        />
      )}

      {openRemoveDialog && (
        <DisconectAtsDialog
          integrationName={atsService.name}
          onClose={() => {
            setOpenRemoveDialog(false);
          }}
          onRemove={() => {
            setOpenRemoveDialog(false);
            deleteAshby.mutate(undefined, {
              onSuccess: () => {
                onRemove?.();
              },
            });
          }}
        />
      )}
    </>
  );
};

export default AshbyCard;
